<!-- Replace m-4 with header-block to control spacing precisely -->
<div class="header-block ">
  <h6 class="title text-center">
    {{ "Our career coaching's certificates" | translate }}
  </h6>
  <p class="text-center">
    {{
    "All you need to verify and trust with our career coaching, we will with you until find your dream job, only with Up
    career"
    | translate
    }}
  </p>
</div>

<p-galleria [value]="cvTempletes" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
  [responsiveOptions]="responsiveOptions" [containerStyle]="{}" [numVisible]="7" [circular]="true" [fullScreen]="true"
  [showItemNavigators]="true" [showThumbnails]="false">
  <ng-template pTemplate="item" let-item>
    <img [src]="item" style="width: 100%; object-fit: cover; z-index: 6000" />
  </ng-template>
</p-galleria>

<p-carousel [value]="cvTempletes" [numVisible]="4" [numScroll]="1" [showIndicators]="false"
  [responsiveOptions]="responsiveOptions" dir="ltr">
  <ng-template let-item let-i="index" pTemplate="item">
    <img [src]="item" (click)="imageClick(cvTempletes.indexOf(item))" class="border-round" style="cursor: pointer" />
  </ng-template>
</p-carousel>